// holidaySummaryColumnDefs.ts
import { MRT_ColumnDef } from 'mantine-react-table';
import { Text } from '@mantine/core';
import type { CSSProperties } from 'react';
import { formatDateToShow, stringToDate } from 'app/utils/util-functions';
import IonIcon from '@reacticons/ionicons';

const getTextStyle = (weight: number, lineHeight: string): CSSProperties => ({
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '14px',
    fontWeight: weight,
    lineHeight: lineHeight,
    textAlign: 'start',
    color: '#413E3E',
    width: '100%',
});

function TableHead({ header }: { header: string }) {
    return <Text style={getTextStyle(700, '22px')}>{header}</Text>;
}

export const getHolidaySummaryColumnDefs = (
    deleteRow: (index: number) => void
): MRT_ColumnDef<any>[] => [
        {
            header: 'Name',
            accessorKey: 'holidayName',
            Header: () => <TableHead header="Holiday Name" />,
            Cell: ({ cell }) => (
                <Text style={getTextStyle(600, '19px')}>{cell.getValue<string>()}</Text>
            ),
        },
        {
            header: 'Date',
            accessorKey: 'holidayDate',
            Header: () => <TableHead header="Holiday Date" />,
            Cell: ({ cell }) => {
                const value = cell.getValue<string>();
                const date = formatDateToShow(value ? stringToDate(value) : undefined);
                return <Text style={getTextStyle(600, '19px')}>{date}</Text>;
            },
        },
        {
            id: 'delete',
            header: '',
            Header: () => <TableHead header="" />,
            Cell: ({ row }) => (
                <IonIcon
                    name="trash-outline"
                    style={{ color: 'black', cursor: 'pointer', width: '25px', height: '25px' }}
                    className="click-ion-icon"
                    onClick={() => deleteRow(row.original)}
                />
            ),
            mantineTableBodyCellProps: {
                style: { padding: '0px' },
            },
            size: 50,
            enableSorting: false,
            enableColumnActions: false,
        }

    ];
